export default {
  childCategories: {
    label: "Underkategorier"
  },
  menu: {
    toParent: {
      label: "Alla {{categoryName}}"
    }
  }
}